import React from 'react';

interface RTELoadingOverlayProps {
    svg: string;
    dataCy?: string;
}

function RTELoadingOverlay({ svg, dataCy }: RTELoadingOverlayProps): React.JSX.Element {
    return (
        <div
            className="bg-background border-border flex h-full w-full flex-col items-center justify-center border"
            data-cy={dataCy}
        >
            <object type="image/svg+xml" data={svg} aria-label="overlay" />
        </div>
    );
}

export default RTELoadingOverlay;
